module.exports = __webpack_public_path__ + "images/404-9b5da005.png";